import React from 'react';
import { Poppins } from 'src/common';
import * as S from './GTModifierLabel.styles';

interface GTModifierLabelProps {
  length: number;
  satisfiesModifier?: boolean;
  plainText?: boolean;
}

export const GTModifierLabel: React.FC<GTModifierLabelProps> = ({ length, satisfiesModifier = true, plainText }) => {
  const text = `${length} Modifier${length === 1 ? '' : 's'}`;

  if (plainText) {
    return <Poppins px={14}>{text}</Poppins>;
  }
  return (
    <S.Label px={14} $disabled={!satisfiesModifier} $underline weight={500}>
      {text}
    </S.Label>
  );
};
